import React from 'react';
import DecisionFactorsTemplate from '../decisionFactorsTemplate/DecisionFactorsTemplate';

const pageTitle = 'Lifestyle Impact of Recovery';
const pageSubTitle = 'Lifestyle Impact of Recovery';
const videoKey = '19EEykSM3VQ';

const LifestyleImpactOfRecovery = () => {

    return (
        <DecisionFactorsTemplate
            pageTitle={pageTitle}
            pageSubTitle={pageSubTitle}
            videoKey={videoKey}
            pageDescription={
                <p>
                    Lifestyle Impact of Recovery reflects how important it is to minimize disruptions to
                    everyday life during the recovery process. This includes needing time off work,
                    relying on help at home, or being unable to carry out daily activities.
                    <br/>
                    For example,
                    Total Knee Replacement often involves a longer recovery and more support at home. In
                    contrast, NSAIDs typically have minimal impact on daily routines. This criterion
                    helps surface treatments that align better with day-to-day responsibilities and
                    lifestyle needs.
                </p>
            }
            pageType="criteria"
        />
    );

};

export default LifestyleImpactOfRecovery;